<div class="tw:p-[20px] tw:border-b tw:border-b-[#eee]">
  <div class="tw:flex tw:items-center tw:gap-[16px] tw:flex-wrap">
    <span class="tw:text-[15px] tw:font-semibold tw:text-[#333] tw:min-w-[140px]">{{ student.name }}</span>

    @if (!savedAttendance) {
    @if (!disabled) {
    <div class="tw:flex tw:gap-[8px] tw:flex-wrap">
      @for (opt of options; track opt.value) {
      <button mat-button
              class="tw:!text-[12px] tw:!font-semibold tw:border-0 {{ opt.cssClass }}"
              (click)="selectAttendance(opt.value)">
        {{ opt.label }}
      </button>
      }
    </div>
    }
    } @else {
    <div class="tw:flex tw:items-center tw:gap-[10px]">
      <span class="tw:inline-flex tw:items-center tw:py-[5px] tw:px-3.5 tw:rounded-full tw:text-[15px] tw:font-bold tw:border-2 {{ pillClass }}">✓ {{ pillLabel }}</span>
      @if (!disabled) {
      <button type="button"
              class="change-link tw:text-[14px] tw:bg-transparent tw:border-0 tw:p-0 tw:cursor-pointer"
              (click)="changeAttendance()">Change</button>
      }
    </div>
    }
  </div>

  @if (savedAttendance && savedAttendance.status != 'Present') {
  <div class="tw:mt-[16px] tw:px-[14px] tw:py-[12px] tw:border tw:border-[#e0e0e0] tw:rounded-[3px] tw:text-[14px] tw:text-[#333] tw:leading-[1.7]">

    @if (savedAttendance.reason) {
    <div class="tw:flex tw:gap-[6px] tw:mb-[4px]">
      <span class="tw:text-[#888] tw:min-w-[140px] tw:flex-shrink-0">Reason:</span>
      <span>{{ savedAttendance.reason }}</span>
    </div>
    }

    @if (savedAttendance.comments) {
    <div class="tw:flex tw:gap-[6px] tw:mb-[4px]">
      <span class="tw:text-[#888] tw:min-w-[140px] tw:flex-shrink-0">Comments:</span>
      <span>{{ savedAttendance.comments }}</span>
    </div>
    }

    @if (savedAttendance.parentCarerInformed) {
    <div class="tw:flex tw:gap-[6px] tw:mb-[4px]">
      <span class="tw:text-[#888] tw:min-w-[140px] tw:flex-shrink-0">Parent/carer informed:</span>
      <span>{{ savedAttendance.parentCarerInformed === 'yes' ? 'Yes' : 'No' }}</span>
    </div>
    }
  </div>
  }
</div>
